export enum GPTPromptRoleType {
    SYSTEM = 'system',
    ASSISTANT = 'assistant',
    USER = 'user'
}

export interface GPTPrompt {
    role: GPTPromptRoleType
    content: string
}


export interface LlmConfig {
    _id: string;
    provider: string;
    models: string[]
    createdAt: string;
    updatedAt: string;
}
